(() => {
  const initTabs = (root) => {
    if (root.classList.contains('is-ready')) return;
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = tabs.map((tab) => root.querySelector('#' + tab.getAttribute('aria-controls')));

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (panels[i]) panels[i].hidden = !active;
      });
      if (focus) tabs[index].focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          event.preventDefault();
          select(next, true);
        }
      });
    });

    root.classList.add('is-ready');
    select(0, false);
  };

  const initSticky = (bar) => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const form = document.getElementById(bar.dataset.form);
    const button = bar.querySelector('[data-aur-sticky-btn]');
    const price = bar.querySelector('[data-aur-sticky-price]');
    const sectionId = bar.dataset.section;
    if (!form) return;

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (button) button.tabIndex = visible ? 0 : -1;
    };

    const anchor = form.querySelector('[type="submit"]') || form;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0),
        { threshold: 0 }
      ).observe(anchor);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && button) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data;
        if (!data || data.sectionId !== sectionId) return;
        const variant = data.variant;
        if (!variant) {
          button.disabled = true;
          button.textContent = button.dataset.labelNa;
          return;
        }
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.labelAdd : button.dataset.labelSold;
        if (price && data.html) {
          const source = data.html.getElementById('price-' + sectionId);
          if (source) {
            const onSale = source.querySelector('.price--on-sale');
            const node = onSale
              ? source.querySelector('.price__sale .price-item--last')
              : source.querySelector('.price__regular .price-item--regular');
            if (node) price.textContent = node.textContent.trim();
          }
        }
      });
    }
  };

  const initDesc = (root) => {
    const body = root.querySelector('[data-aur-desc-body]');
    const toggle = root.querySelector('[data-aur-desc-toggle]');
    if (!body || !toggle || root.dataset.aurReady) return;
    root.dataset.aurReady = 'true';
    if (body.scrollHeight <= 340) return;
    root.classList.add('is-clamped');
    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      const open = root.classList.toggle('is-clamped') === false;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
    });
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-aur-desc]').forEach(initDesc);
    scope.querySelectorAll('[data-aur-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-aur-sticky]').forEach(initSticky);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
